"use client"
import { useState, useEffect } from "react"
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  BottomNavigation,
  BottomNavigationAction,
} from "@mui/material"
import {
  ArrowBack as ArrowBackIcon,
  Home as HomeIcon,
  CalendarToday as CalendarTodayIcon,
  Payment as PaymentIcon,
  Notifications as NotificationsIcon,
  AccountCircle as AccountCircleIcon,
} from "@mui/icons-material"
import { useNavigate } from "react-router-dom"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import ExitToAppIcon from "@mui/icons-material/ExitToApp"
import { GiHorseHead } from "react-icons/gi"
import HorsePensionDetails from "./HorsePensionDetails"


export default function DetailPension() {
  const navigate = useNavigate()
  const [userRole, setUserRole] = useState("member") // Default to member

  // Get user role from localStorage on component mount
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"))
    if (user && user.role) {
      setUserRole(user.role)
    }
  }, [])

  // Get the home route based on user role
  const getHomeRoute = () => {
    switch (userRole) {
      case "admin":
        return "/Admin"
      case "instructor":
        return "/InstructorHome"
      default:
        return "/home"
    }
  }

  // Get the profile route based on user role
  const getProfileRoute = () => {
    return userRole === "admin" ? "/ProfileAdmin" : "/Profile"
  }

  // Get the notifications route based on user role
  const getNotificationsRoute = () => {
    return userRole === "admin" ? "/AdminGetNotifs" : "/notifications"
  }

  // Get the payment route based on user role
  const getPaymentRoute = () => {
    return userRole === "admin" ? "/AdminPaiment" : "/payment"
  }

  // Get the calendar route based on user role
  const getCalendarRoute = () => {
    return userRole === "admin" ? "/AdminChrono" : "/emploi"
  }

  // Logout function
  const handleLogout = () => {
    localStorage.removeItem("CC_Token")
    localStorage.removeItem("user")
    navigate("/login")
  }

  const handleNavigateToNotifications = () => {
    navigate(getNotificationsRoute())
  }

  const handleProfile = () => {
    navigate(getProfileRoute())
  }

  return (
    <div className="app">
      <ToastContainer />

      {/* Header */}
      <AppBar position="fixed" sx={{ backgroundColor: "#003366" }}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={() => navigate(getHomeRoute())} sx={{ mr: 1 }}>
            <ArrowBackIcon />
          </IconButton>
          <Avatar alt="Logo" src={"../assets/cej.png"} sx={{ width: 40, height: 40, marginRight: "0.5rem" }} />
          <Typography
            variant="h6"
            sx={{
              flexGrow: 1,
              fontSize: { xs: "1rem", sm: "1.25rem" },
              color: "#ffffff",
            }}
          >
            Détails des Pensions
          </Typography>
          <IconButton color="inherit" onClick={handleNavigateToNotifications}>
            <NotificationsIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleProfile}>
            <AccountCircleIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleLogout}>
            <ExitToAppIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Main Content */}
      <Box
        sx={{
          padding: "1rem",
          paddingTop: "70px",
          paddingBottom: "70px",
          backgroundColor: "#f5f5f5",
        }}
      >
        {/* Page Title with Horse Icon */}
        <Box sx={{ display: "flex", alignItems: "center", mb: 3, mt: 2 }}>
          <GiHorseHead style={{ fontSize: 48, color: "#b8860b", marginRight: "16px" }} />
          <Typography variant="h5" component="h1" sx={{ fontWeight: "bold", color: "#003366" }}>
            Détails des Pensions
          </Typography>
        </Box>
        <Paper elevation={2} sx={{ mb: 4, p: 2, backgroundColor: "#f0f7ff", border: "1px solid #b8d0e8" }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box
              sx={{
                backgroundColor: "#003366",
                borderRadius: "50%",
                width: 40,
                height: 40,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mr: 2,
              }}
            >
              <GiHorseHead style={{ fontSize: 24, color: "white" }} />
            </Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", color: "#003366" }}>
              Résultats de notre système d'alimentation
            </Typography>
          </Box>
          <Typography variant="body1" sx={{ mt: 2, fontStyle: "italic", pl: 6 }}>
            Depuis Juin 2023 (deux ans), 0 cas de colique et ulcère gastrique au club, grâce au fourrage riche en fibre
            de qualités et suffisant ainsi au système basé sur des horaires de ration fixe avec une bonne quantités et
            qualités des ingrédients (SNA).
          </Typography>
        </Paper>

        {/* First Table: Alimentation des chevaux */}
        <Paper elevation={2} sx={{ mb: 4, overflow: "hidden" }}>
          <Box sx={{ p: 2, backgroundColor: "#003366", color: "white", display: "flex", alignItems: "center" }}>
            <GiHorseHead style={{ fontSize: 28, marginRight: "16px" }} />
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Annexe I : Alimentation des chevaux selon le type de la pension
            </Typography>
          </Box>
          <TableContainer>
            <Table aria-label="alimentation table">
              <TableHead sx={{ backgroundColor: "#f0f0f0" }}>
                <TableRow>
                  <TableCell sx={{ border: "1px solid #ddd" }}></TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bold", color: "#003366", border: "1px solid #ddd" }}>
                    PENSION 1
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bold", color: "#003366", border: "1px solid #ddd" }}>
                    PENSION 2
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell component="th" scope="row" sx={{ fontWeight: "bold", border: "1px solid #ddd" }}>
                    UFC
                  </TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}>
                    4.5
                  </TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}>
                    6
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row" sx={{ fontWeight: "bold", border: "1px solid #ddd" }}>
                    FOINS (Alimentation de base)
                  </TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}>
                    7,5 balles par mois (soit ¼ de balle par jour)
                  </TableCell>

                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}>
                    10 balles par mois (soit ⅓ de balle par jour)
                  </TableCell>
                </TableRow>
                <TableRow sx={{ backgroundColor: "#f9f9f9" }}>
                  <TableCell colSpan={3} sx={{ fontWeight: "bold", border: "1px solid #ddd" }}>
                    + Granules / Complements :
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row" sx={{ fontWeight: "bold", border: "1px solid #ddd" }}>
                    SNA SPORT
                  </TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}>
                    1-0.5
                  </TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}>
                    1-1
                  </TableCell>
                </TableRow>
                <TableRow sx={{ backgroundColor: "#f9f9f9" }}>
                  <TableCell component="th" scope="row" sx={{ fontWeight: "bold", border: "1px solid #ddd" }}>
                    SNA ELEVAGE
                  </TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}>
                    1-0.5
                  </TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}>
                    1-1
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row" sx={{ fontWeight: "bold", border: "1px solid #ddd" }}>
                    SNA ENTRETIENT
                  </TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}>
                    1-1
                  </TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}>
                    1.5-1.5
                  </TableCell>
                </TableRow>
                <TableRow sx={{ backgroundColor: "#f9f9f9" }}>
                  <TableCell component="th" scope="row" sx={{ fontWeight: "bold", border: "1px solid #ddd" }}>
                    ORGE
                  </TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}>
                    1.5-1.5
                  </TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}>
                    2.5-2.5
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        {/* Second Table: Litières des chevaux */}
        <Paper elevation={2} sx={{ mb: 4, overflow: "hidden" }}>
          <Box sx={{ p: 2, backgroundColor: "#003366", color: "white", display: "flex", alignItems: "center" }}>
            <GiHorseHead style={{ fontSize: 28, marginRight: "16px" }} />
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Annexe II : Litières des chevaux selon le type de la pension par jour
            </Typography>
          </Box>
          <TableContainer>
            <Table aria-label="litières table">
              <TableHead sx={{ backgroundColor: "#f0f0f0" }}>
                <TableRow>
                  <TableCell rowSpan={2} sx={{ border: "1px solid #ddd" }}></TableCell>
                  <TableCell
                    rowSpan={2}
                    align="center"
                    sx={{ fontWeight: "bold", color: "#003366", border: "1px solid #ddd" }}
                  >
                    Totale/mois
                  </TableCell>
                  <TableCell
                    rowSpan={2}
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      color: "#003366",
                      border: "1px solid #ddd",
                      fontSize: "0.85rem",
                      minWidth: "150px",
                      width: "180px",
                      whiteSpace: "normal",
                      padding: "8px 12px",
                    }}
                  >
                    Début du mois
                    <br />
                    Curage totale du box +
                  </TableCell>
                  <TableCell colSpan={7} align="center" sx={{ fontWeight: "bold", color: "#003366" }}>
                    Jours de la semaine
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="center" sx={{ fontWeight: "bold", color: "#003366", border: "1px solid #ddd" }}>
                    Lundi
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bold", color: "#003366", border: "1px solid #ddd" }}>
                    Mardi
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bold", color: "#003366", border: "1px solid #ddd" }}>
                    Mercredi
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bold", color: "#003366", border: "1px solid #ddd" }}>
                    Jeudi
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bold", color: "#003366", border: "1px solid #ddd" }}>
                    Vendredi
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bold", color: "#003366", border: "1px solid #ddd" }}>
                    Samedi
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bold", color: "#003366", border: "1px solid #ddd" }}>
                    Dimanche
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {/* PENSION 1 */}
                <TableRow sx={{ backgroundColor: "#e6f2ff" }}>
                  <TableCell colSpan={10} sx={{ fontWeight: "bold", color: "#003366", border: "1px solid #ddd" }}>
                    PENSION 1
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row" sx={{ fontWeight: "bold", border: "1px solid #ddd" }}>
                    Pailles
                  </TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}>
                    5 balles
                  </TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}>
                    1 balle
                  </TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}></TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}>
                    1 balle
                  </TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}></TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}></TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}></TableCell>
                </TableRow>
                <TableRow sx={{ backgroundColor: "#f9f9f9" }}>
                  <TableCell component="th" scope="row" sx={{ fontWeight: "bold", border: "1px solid #ddd" }}>
                    Copeaux de bois
                  </TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}>
                    12 sacs
                  </TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}>
                    4 sacs
                  </TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}></TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}>
                    1 sac
                  </TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}></TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}></TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}>
                    1 sac
                  </TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}></TableCell>
                </TableRow>

                {/* PENSION 2 */}
                <TableRow sx={{ backgroundColor: "#e6f2ff" }}>
                  <TableCell colSpan={10} sx={{ fontWeight: "bold", color: "#003366", border: "1px solid #ddd" }}>
                    PENSION 2
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row" sx={{ fontWeight: "bold", border: "1px solid #ddd" }}>
                    Pailles
                  </TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}>
                    14 balles
                  </TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}>
                    2 balles
                  </TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}></TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}>
                    1 balle
                  </TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}></TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}>
                    1 balle
                  </TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}></TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}>
                    1 balle
                  </TableCell>
                </TableRow>
                <TableRow sx={{ backgroundColor: "#f9f9f9" }}>
                  <TableCell component="th" scope="row" sx={{ fontWeight: "bold", border: "1px solid #ddd" }}>
                    Copeaux de bois
                  </TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}>
                    30 sacs
                  </TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}>
                    6 sacs
                  </TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}>
                    1 sac
                  </TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}>
                    1 sac
                  </TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}>
                    1 sac
                  </TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}>
                    1 sac
                  </TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}>
                    1 sac
                  </TableCell>
                  <TableCell align="center" sx={{ border: "1px solid #ddd" }}>
                    1 sac
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        {/* Recommandations */}
        <Paper elevation={2} sx={{ mb: 4, overflow: "hidden" }}>
          <Box sx={{ p: 2, backgroundColor: "#003366", color: "white", display: "flex", alignItems: "center" }}>
            <GiHorseHead style={{ fontSize: 28, marginRight: "16px" }} />
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Nos recommandations
            </Typography>
          </Box>
          <Box sx={{ p: 3 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 2, color: "#003366" }}>
              Recommandations générales pour l'alimentation et les litières
            </Typography>

            <Typography variant="body1" sx={{ mb: 1 }}>
              • 1.5 kg/ 100 kg poids du cheval par jour en matière sèche, nos balles de foins pèse environ 25kg/balle.
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              • 2 kg/ 100 kg poids du cheval par jour en matière sèche pour les juments en allaitement, sois ½ balle de
              foins/jour
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              • On recommande une quantité d'aliment comprise entre 0,5 et 1,2 kg pour 100 kg de poids vif par jour,
              selon l'intensité du travail. Donc pour un cheval de 500 kg, ça peut aller de 2,5 kg à 6 kg par jour,
              répartis en 2 ou 3 rations.
            </Typography>

            <Typography variant="body1" sx={{ mb: 1, pl: 2, borderLeft: "3px solid #b8860b", py: 1 }}>
              <strong>NB:</strong> Pour notre pension 2, On donnera 1-1 SNA sport (1 boite de thon = 1,3 kg granulés)
              sois 2,6kg/jour recommandé à un cheval de 500kg. Par contre, au période du concours (travail intense) il
              est fortement recommandé de rajouter 0,5 jusqu'à 1 par ration (1,3kg jusqu'à 2,6kg) pour un cheval de
              500kg sois un totale entre 4 et 6kg de granulés SNA SPORT/jour
            </Typography>

            <Typography variant="subtitle2" sx={{ fontWeight: "bold", mt: 3, mb: 1, color: "#003366" }}>
              Pension 1
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              • La pension 1 est recommandée pour les double poneys de type C-D d'un poids qui ne dépasse pas les 400 kg
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              • Pour un poney de 400kg (poids), il a besoin de 4x1.5kg de foins par jour, 6 kg matière sèche/jour.
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              • ¼ balle de foins par jour : environ 6kg de matière sèche.
            </Typography>

            <Typography variant="subtitle2" sx={{ fontWeight: "bold", mt: 3, mb: 1, color: "#003366" }}>
              Pension 2
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              • La pension 2 est recommandée pour les chevaux et les doubles poneys avec du travail intensif
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              • Pour un cheval de 500kg (poids), il a besoin de 5x1.5kg de foins par jour, 7.5 kg matière sèche/jour.
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              • 1/3 balle de foins par jour : environ 8 kg de matière sèche.
            </Typography>

            <Typography variant="subtitle2" sx={{ fontWeight: "bold", mt: 3, mb: 1, color: "#003366" }}>
              Types de granulés
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              • <strong>SNA SPORT</strong> : Granulés à base de l'orge et l'avoine recommandée pour les chevaux adulte
              athlète qui participe à la compétition riche en amidon (Energie) et oméga 3
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              • <strong>SNA ELEVAGE</strong> : Granulé riche en protéine à base de luzerne et soja recommandé pour les
              jeunes chevaux en croissance (poulains, yearlings) pour construire les muscles, les tissus et favoriser un
              développement général ainsi destiné au juments gestante et allaitantes à fin de produire suffisamment de
              lait.
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              • <strong>SNA ENTRETIENT</strong> : Granulé riche en Omega 3 à base des grains de lin pour avoir un effet
              anti-inflammatoire, une bonne qualité de peu et des crins ainsi elle soutien le système immunitaire.
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              • <strong>ORGE</strong> : Riche en amidon, elle apporte beaucoup d'énergie utile pour les chevaux de sport
              ou de travail MAIS pas riche en fibre, peut déséquilibrer le macrobiote intestinal du cheval et un risque
              d'ulcère gastrique.
            </Typography>

            <Typography variant="subtitle2" sx={{ fontWeight: "bold", mt: 3, mb: 1, color: "#003366" }}>
              Types de litières
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              • <strong>PAILLE</strong> : litière de base, plus de confort par rapport aux copeaux de bois et qui garde
              bien la chaleur MAIS peut favoriser les coliques (si le cheval mange trop)
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              • <strong>COPEAUX DE BOIS</strong> : litière hygiène adaptée pour les chevaux sensibles idéal pour les
              chevaux allergiques ou asthmatiques et moins de risque de colique (Réduit les risques d'ingestion de
              litière)
            </Typography>
          </Box>
        </Paper>

        {/* SNA Nutrition Information */}
        <Paper elevation={2} sx={{ mb: 4, overflow: "hidden" }}>
          <Box sx={{ p: 2, backgroundColor: "#003366", color: "white", display: "flex", alignItems: "center" }}>
            <GiHorseHead style={{ fontSize: 28, marginRight: "16px" }} />
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Informations nutritionnelles SNA
            </Typography>
          </Box>
          <Box sx={{ p: 3 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 2, color: "#003366" }}>
              Chez SNA, nous comprenons l'importance d'une nutrition adaptée
            </Typography>

            <Box sx={{ display: "flex", justifyContent: "center", my: 3 }}>
              {/* Remplacé le composant Image par Box avec component="img" */}
              <Box
                component="img"
                src="../assets/sna.jpg"
                alt="Informations nutritionnelles SNA"
                sx={{
                  maxWidth: "100%",
                  height: "auto",
                  width: 600,
                  maxHeight: 800
                }}
              />
            </Box>

            <Typography variant="body1" sx={{ mt: 2, fontStyle: "italic" }}>
              Notre gamme d'aliments est spécialement conçue pour répondre aux besoins spécifiques des chevaux selon
              leur activité et état physiologique.
            </Typography>
          </Box>
        </Paper>

        {/* Horse Pension Details Component */}
        <HorsePensionDetails userRole={userRole} />
      </Box>

      {/* Footer */}
      <Box sx={{ position: "fixed", bottom: 0, width: "100%", zIndex: 1000 }}>
        <BottomNavigation
          sx={{
            backgroundColor: "#003366",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <BottomNavigationAction
            label="Calendrier"
            icon={<CalendarTodayIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
            sx={{ color: "#ffffff", minWidth: "auto" }}
            onClick={() => navigate(getCalendarRoute())}
          />
          <BottomNavigationAction
            label="Home"
            icon={<HomeIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
            sx={{ color: "#ffffff", minWidth: "auto" }}
            onClick={() => navigate(getHomeRoute())}
          />
          <BottomNavigationAction
            label="Paiement"
            icon={<PaymentIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
            sx={{ color: "#ffffff", minWidth: "auto" }}
            onClick={() => navigate(getPaymentRoute())}
          />
        </BottomNavigation>
      </Box>
    </div>
  )
}
